import contextEvent from 'app/common/lib/ContextEvent';
import contextLogger from 'app/common/lib/ContextLogger';

const unauthRankingLog = (event, view, viewParameter, element, component, loggingData, pin) => {
  const eventDict = {
    event_type: event,
    view_type: view,
    view_parameter: viewParameter,
    element,
    component,
  };
  const _contextEvent = contextEvent.fromPlainObject(eventDict);

  // Add required fields for unauth ranking in aux data
  const auxDataMap = {};
  if (loggingData && loggingData.id && loggingData.id.length > 0) {
    if (view === PCONST.thrift.ViewType.FEED) {
      auxDataMap.unauth_page_klp_id = loggingData.id;
      auxDataMap.unauth_page_klp_name = loggingData.url_name;
    } else if (view === PCONST.thrift.ViewType.PIN) {
      auxDataMap.unauth_page_pin_id = loggingData.id;
      auxDataMap.unauth_page_pin_image_signature = loggingData.image_signature;
    } else if (view === PCONST.thrift.ViewType.BOARD) {
      auxDataMap.unauth_page_board_id = loggingData.id;
    }
    auxDataMap.unauth_click_pin_id = pin.id;
    auxDataMap.unauth_click_pin_image_signature = pin.image_signature;
  }
  _contextEvent.updateAuxData(auxDataMap);
  contextLogger.getInstance().addEvent(_contextEvent);
};

export default unauthRankingLog;
